
export default function Policy() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            운영정책 및 안내사항
          </h2>
          <p className="text-xl text-gray-600">
            투명하고 체계적인 교육 프로그램 운영
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* 운영정책 */}
          <div className="bg-gray-50 rounded-2xl p-8">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                <i className="ri-file-text-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800">운영정책</h3>
            </div>

            <div className="space-y-6">
              <div>
                <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                  <i className="ri-money-dollar-circle-line text-green-600 mr-2"></i>
                  회비 및 결제
                </h4>
                <ul className="text-gray-600 space-y-1 ml-6">
                  <li>• 월 회비: 2,990원 (부가세 포함)</li>
                  <li>• 매월 1일 자동 결제</li>
                  <li>• 첫 달 무료 체험 제공</li>
                  <li>• 카드, 계좌이체 결제 가능</li>
                </ul>
              </div>

              <div>
                <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                  <i className="ri-calendar-check-line text-blue-600 mr-2"></i>
                  자료 제공
                </h4>
                <ul className="text-gray-600 space-y-1 ml-6">
                  <li>• 매주 화요일 철학 자료 발송</li>
                  <li>• 이메일 및 문자로 전송</li>
                </ul>
              </div>

              <div>
                <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                  <i className="ri-user-settings-line text-purple-600 mr-2"></i>
                  회원 관리
                </h4>
                <ul className="text-gray-600 space-y-1 ml-6">
                  <li>• 언제든지 해지 가능</li>
                  <li>• 해지 시 당월 말까지 서비스 제공</li>
                  <li>• 개인정보 보호 철저 준수</li>
                  <li>• 학부모 동의 필수 (미성년자)</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 교육 방침 */}
          <div className="bg-blue-50 rounded-2xl p-8">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                <i className="ri-graduation-cap-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800">교육 방침</h3>
            </div>

            <div className="space-y-6">
              <div>
                <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                  <i className="ri-target-line text-red-600 mr-2"></i>
                  교육 목표
                </h4>
                <ul className="text-gray-600 space-y-1 ml-6">
                  <li>• 철학적 사고력 향상</li>
                  <li>• 올바른 가치관 형성</li>
                  <li>• 리더십과 인성 개발</li>
                  <li>• 행복한 삶의 지혜 습득</li>
                </ul>
              </div>

              <div>
                <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                  <i className="ri-book-open-line text-orange-600 mr-2"></i>
                  교육 내용
                </h4>
                <ul className="text-gray-600 space-y-1 ml-6">
                  <li>• 동서양 철학 기초</li>
                  <li>• 실생활 적용 사례</li>
                  <li>• 토론과 글쓰기 활동</li>
                  <li>• 명상과 성찰 시간</li>
                </ul>
              </div>

              <div>
                <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                  <i className="ri-shield-check-line text-teal-600 mr-2"></i>
                  품질 보장
                </h4>
                <ul className="text-gray-600 space-y-1 ml-6">
                  <li>• 전문 철학 교육진 운영</li>
                  <li>• 체계적인 커리큘럼</li>
                  <li>• 정기적인 만족도 조사</li>
                  <li>• 지속적인 프로그램 개선</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* 문의 및 지원 */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white">
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-4">문의 및 지원</h3>
            <p className="text-lg mb-6 opacity-90">
              궁금한 점이 있으시면 언제든지 연락주세요
            </p>
            
            <div className="grid md:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-phone-line text-2xl"></i>
                </div>
                <h4 className="font-semibold mb-2">전화 상담</h4>
                <p className="text-sm opacity-90">평일 09:00 - 18:00</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-mail-line text-2xl"></i>
                </div>
                <h4 className="font-semibold mb-2">이메일 문의</h4>
                <p className="text-sm opacity-90">24시간 접수 가능</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-chat-3-line text-2xl"></i>
                </div>
                <h4 className="font-semibold mb-2">실시간 채팅</h4>
                <p className="text-sm opacity-90">우측 하단 채팅 버튼</p>
              </div>
            </div>

            <button
              onClick={() => {
                const agentButton = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
                if (agentButton) {
                  agentButton.click();
                }
              }}
              className="bg-white text-blue-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-customer-service-2-line mr-2"></i>
              지금 상담받기
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
